import { createDefaultInstanceGetter } from '@/stores/utils';

export class CompositeBusinessStore {}

export const getDefaultCompositeBusinessStore = createDefaultInstanceGetter(
    CompositeBusinessStore,
);
